var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"pa-0 breakdown-bg",attrs:{"colspan":_vm.headers.length}},[_c('div',{staticClass:"pa-6"},[_c('div',{staticClass:"text-subtitle-2 font-weight-medium mb-4 breakdown-title"},[_vm._v(" "+_vm._s(_vm.$t('billing.breakdown.title'))+" ")]),_c('invoice-breakdown-table',{attrs:{"breakdown":_vm.item.breakdown}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }